import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveService } from '@service/responsive.service';

@Component({
    selector: 'app-ops-alarm-to-top',
    templateUrl: './ops-alarm-to-top.component.html',
    styleUrls: ['./ops-alarm-to-top.component.scss'],
    standalone: false
})
export class OpsAlarmToTopComponent {
    @Output() onTopEmit = new EventEmitter();

    onTop() {
        this.onTopEmit.emit();
    }

    constructor(public responsive: ResponsiveService) {}
}
